// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1111":"23820448660365d2","3991":"6b27115f04bb939c","5203":"85d48c6e2c678069"}[chunkId] + ".css";
};